import theme from '../../../lib/theme';

const {
  layouts,
  colors,
  scale,
  media,
  font: { families, heights, spacings, ...font },
} = theme;

export default () => ({
  container: {
    ...layouts.column,
    backgroundColor: '#fff',

    alignItems: 'center',
    padding: `${scale.l} ${scale.xs}`,
  },
  titleText: {
    h1: {
      fontSize: '2.5rem',
      fontWeight: '700',
      lineHeight: '3rem',
      marginBottom: 0,
    },
  },
});
